import { uniq } from 'ramda';

const getFormats = (delimiter, dateFormat, timeFormat) => {
  if (!dateFormat.includes(delimiter)) {
    return [dateFormat];
  }

  const dateFormatArray = dateFormat.split(delimiter);
  const noSpaceFormat = dateFormatArray.map(it => it.trim()).join(delimiter);
  const spaceLeftFormat = dateFormatArray
    .map(it => ` ${it.trim()}`)
    .join(delimiter)
    .trim();
  const spaceRightFormat = dateFormatArray
    .map(it => `${it.trim()} `)
    .join(delimiter)
    .trim();
  const spaceBothFormat = dateFormatArray
    .map(it => ` ${it.trim()} `)
    .join(delimiter)
    .trim();
  const noDelimiterFormat = dateFormatArray
    .map(it => ` ${it.trim()} `)
    .join(' ')
    .trim();

  let dateTimeFormats = [`${dateFormat} ${timeFormat ? timeFormat : ''}`.trim()];
  if (timeFormat) {
    dateTimeFormats = [
      ...dateTimeFormats,
      `${dateFormat} ${timeFormat.replace(':', '.')}`,
      `${dateFormat} ${timeFormat.replace(':', ' ')}`,
      `${dateFormat} ${timeFormat.replace('.', ':')}`,
      `${dateFormat} ${timeFormat.replace('.', ' ')}`,
    ];
  }

  return [
    dateTimeFormats[0],
    dateFormat,
    noSpaceFormat,
    spaceLeftFormat,
    spaceRightFormat,
    spaceBothFormat,
    noDelimiterFormat,
    ...dateTimeFormats,
  ];
};

export const getDateFormats = (dateFormat, timeFormat) =>
  uniq([
    ...getFormats('.', dateFormat, timeFormat),
    ...getFormats('/', dateFormat, timeFormat),
    ...getFormats('\\', dateFormat, timeFormat),
  ]);
